export default {
	type: 'ARTICLE_FAVORITE',
	name: 'Favorite',
	allowedSections: ['article', 'main'],
	disallowedChildren: ['*'],
	category: 'Article',
	props: []
};
